import React, { useEffect, useMemo, useState } from 'react'
import Heading from '../../../../../components/common-components/heading/Heading'
import { HEADING } from '../../../../../components/common-components/heading/Constants'
import { ABDM_PROFILES, ABHA_HEALTH_RECORD_NAVS } from '../Constants';
import DiagnosticRecord from '../Records/DiagnosticRecord';
import PrescriptionRecord from '../Records/PrescriptionRecord';
import { componentKey, setBundlePushError, setBundlePushResponse, setBundleSaveResponse, setSelectedBundle } from '../../PatientDashboardSlice';
import { useDispatch, useSelector } from 'react-redux';
import DischargeSummary from '../Records/DischargeSummary';
import HealthDocumentRecord from '../Records/HealthDocumentRecord';
import OpConsultation from '../Records/OpConsultationRecord';
import WellnessRecord from '../Records/WellnessRecord';
import ImmunizationRecord from '../Records/ImmunizationRecord';
import InvoiceRecord from '../Records/InvoiceRecord';
import Icons from '../../../../../assets/svgs';
import Label from '../../../../../components/common-components/label/Label';
import Input from '../../../../../components/common-components/input/Input';
import { saveBundle } from '../../PatientDashboardSaga';

function AddABHAhealthRecord({handleABHAhealthRecord}) {
    const { patientData, selectedBundle, bundleSaveResponse } = useSelector((state) => state[componentKey]);
    const [selectedType, setSelectedType] = useState(ABDM_PROFILES[0].value)
    const [displayName, setDisplayName] = useState("");
    const [titleError, setTitleError] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [onSave, setOnSave] = useState(false);
    const dispatch = useDispatch()


    const payloadHelper = useMemo (() => ({
        displayName,
        hiType: selectedType,
    }),[displayName, selectedType])

    useEffect(() => {
        if(selectedBundle?.id && patientData?.uuid && onSave){
            const payload = {
                ...payloadHelper,
                patientId: patientData?.uuid,
                bundleData: selectedBundle,
            }
            dispatch(saveBundle(payload));
            dispatch(setSelectedBundle(null));
            setOnSave(false);
        }
    },[dispatch, onSave, payloadHelper, selectedBundle?.id])

    useEffect(() => {
        if(bundleSaveResponse.success){
            handleABHAhealthRecord();
        } else {
            dispatch(setSelectedBundle(null));
        }
    }, [bundleSaveResponse, dispatch])

    const handleSwitchProfiles = (item) => {
        dispatch(setSelectedBundle(null))
        dispatch(setBundlePushError({}))
        dispatch(setBundlePushResponse({}))
        dispatch(setBundleSaveResponse({}))
        setTitleError("");
        setDisplayName("");
        setIsSubmitted(false)
        setSelectedType(item.value);
    }

    useEffect(() => {
        return () => {
            dispatch(setSelectedBundle(null))
            dispatch(setBundlePushResponse({}))
            dispatch(setBundlePushError({}))
            dispatch(setBundleSaveResponse({}))
        }
    }, [dispatch])

    return (
        <div className='flex flex-col w-full h-full gap-4 px-2 py-1'>
            <div className='flex flex-col gap-4'>
                <Heading fontSize="2xl" fontWeight="bold" type={HEADING.H1}>Add ABHA Health Record</Heading>
                <div className='flex gap-4 flex-wrap'>
                    {ABDM_PROFILES.map((item, index) => (
                        <div 
                            key={item.title + index} 
                            className={`border border-gray-200 px-2 py-1 flex gap-4 items-center rounded-md hover:cursor-pointer 
                                shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out transform hover:scale-105
                                ${selectedType === item.value ? "border-2 border-met-primary bg-met-secondary" : ""}`}
                            onClick={() => {
                                handleSwitchProfiles(item)
                            }}
                        >
                            <Icons iconName={item.icon} height={"35px"} width={"35px"} />
                            <Label fontSize={"25px"} fontWeight="bold" customClass="hover:cursor-pointer">
                                {item.title}
                            </Label>
                        </div>
                    
                    ))}
                </div>
            </div>
            <div className='z-50 w-full h-full border-2 rounded-md border-gray-200 py-2 px-4 flex flex-col gap-2 justify-between'>
                <div>
                    <Input
                        label="Record title"
                        placeholder="Please enter record title"
                        value={displayName}
                        isRequired={true}
                        onChangeCb={(e) => {
                            setDisplayName(e.target.value)
                            setTitleError("")
                        }}
                    />
                    {titleError && isSubmitted && (
                        <Label fontSize="md" color="red-500">
                            {titleError}
                        </Label>
                    )}
                </div>
                
                {selectedType === ABHA_HEALTH_RECORD_NAVS.DIAGNOSTIC_REPORT &&
                    <DiagnosticRecord 
                        handleCancle={handleABHAhealthRecord} 
                        payloadHelper={payloadHelper}
                        title = {displayName}
                        setTitleError = {setTitleError}
                        setTitleSubmitted = {setIsSubmitted}
                        setOnSave = {setOnSave}
                    />
                }
                {selectedType === ABHA_HEALTH_RECORD_NAVS.DISCHARGE_SUMMARY &&
                    <DischargeSummary 
                        handleCancle={handleABHAhealthRecord} 
                        payloadHelper={payloadHelper}
                        title = {displayName}
                        setTitleError = {setTitleError}
                        setTitleSubmitted = {setIsSubmitted}
                        setOnSave = {setOnSave}
                    />
                }
                {selectedType === ABHA_HEALTH_RECORD_NAVS.HEALTH_DOCUMENT_RECORD &&
                    <HealthDocumentRecord 
                        handleCancle={handleABHAhealthRecord} 
                        payloadHelper={payloadHelper}
                        title = {displayName}
                        setTitleError = {setTitleError}
                        setTitleSubmitted = {setIsSubmitted}
                        setOnSave = {setOnSave}
                    />
                }
                {selectedType === ABHA_HEALTH_RECORD_NAVS.IMMUNIZATION_RECORD &&
                    <ImmunizationRecord 
                        handleCancle={handleABHAhealthRecord} 
                        payloadHelper={payloadHelper}
                        title = {displayName}
                        setTitleError = {setTitleError}
                        setTitleSubmitted = {setIsSubmitted}
                        setOnSave = {setOnSave}
                    />
                }
                {selectedType === ABHA_HEALTH_RECORD_NAVS.OP_CONSULTATION &&
                    <OpConsultation 
                        handleCancle={handleABHAhealthRecord} 
                        payloadHelper={payloadHelper}
                        title = {displayName}
                        setTitleError = {setTitleError}
                        setTitleSubmitted = {setIsSubmitted}
                        setOnSave = {setOnSave}
                    />
                }
                {selectedType === ABHA_HEALTH_RECORD_NAVS.PRESCRIPTION &&
                    <PrescriptionRecord 
                        handleCancle={handleABHAhealthRecord} 
                        payloadHelper={payloadHelper}
                        title = {displayName}
                        setTitleError = {setTitleError}
                        setTitleSubmitted = {setIsSubmitted}
                        setOnSave = {setOnSave}
                    />
                }
                {selectedType === ABHA_HEALTH_RECORD_NAVS.WELLNESS_RECORD &&
                    <WellnessRecord 
                        handleCancle={handleABHAhealthRecord} 
                        payloadHelper={payloadHelper}
                        title = {displayName}
                        setTitleError = {setTitleError}
                        setTitleSubmitted = {setIsSubmitted}
                        setOnSave = {setOnSave}
                    />
                }
                {selectedType === ABHA_HEALTH_RECORD_NAVS.INVOICE &&
                    <InvoiceRecord 
                        handleCancle={handleABHAhealthRecord} 
                        payloadHelper={payloadHelper}
                        title = {displayName}
                        setTitleError = {setTitleError}
                        setTitleSubmitted = {setIsSubmitted}
                        setOnSave = {setOnSave}
                    />
                }
            </div>
        </div>
    )
}

export default AddABHAhealthRecord;